import { DOCUMENTS_TO_HIDE, DocumentDisplayName } from "@consts/index";

export const isDocumentHidden = (
  fileName: string,
  canSeeInspectionOrderingDocument: boolean
) =>
  DOCUMENTS_TO_HIDE.includes(fileName as DocumentDisplayName) ||
  (!canSeeInspectionOrderingDocument &&
    fileName === DocumentDisplayName.InspectionOrderingDocument);
